import React, { useState } from 'react';
import styles from './PaymentsView.module.css';
import InvoiceList from './InvoiceList';
import InvoiceDetail from './InvoiceDetail';
import OrderDetailPanel from './OrderDetailPanel';
import DownloadModal from './DownloadModal';
import { DownloadButtonPdf, DownloadButtonCsv } from './Styled';
import { formatDate } from '../utils';

const invoiceTitle = inv => inv ? formatDate(inv.audit.createdAt) : 'Select an invoice';
const invoiceKey = inv => inv ? `${inv.placeId}_${inv.audit.createdAt}` : 'empty';

const PaymentsView = ({
  place,
  invoices,
  selectedInvoice,
  orders,
  selectedOrder,
  invoiceSearch,
  orderSearch,
  onSearchInvoice,
  onSearchOrder,
  onSelectInvoice,
  onSelectOrder,
  onCloseOrder,
}) => {
  const [downloadType, setDownloadType] = useState(null);

  return (
    <div className={styles.layout}>
      <InvoiceList
        invoices={invoices}
        selectedInvoice={selectedInvoice}
        search={invoiceSearch}
        onSearchChange={onSearchInvoice}
        onSelectInvoice={onSelectInvoice}
      />

      <div className={styles.right}>
        <div className={styles.rightTopbar}>
          <div className={styles.rightTitle}>{invoiceTitle(selectedInvoice)}</div>
          {selectedInvoice && (
            <div className={styles.dlButtons}>
              <DownloadButtonPdf
                style={{ padding: '6px 13px', fontSize: '12px' }}
                onClick={() => setDownloadType('pdf')}
              >
                📄 PDF Invoice
              </DownloadButtonPdf>
              <DownloadButtonCsv
                style={{ padding: '6px 13px', fontSize: '12px' }}
                onClick={() => setDownloadType('csv')}
              >
                📊 CSV Invoice
              </DownloadButtonCsv>
            </div>
          )}
        </div>

        <div className={styles.rightBody}>
          <div className={styles.detailScroll}>
            <InvoiceDetail
              key={invoiceKey(selectedInvoice)}
              place={place}
              invoice={selectedInvoice}
              orders={orders}
              selectedOrder={selectedOrder}
              orderSearch={orderSearch}
              onSearchOrder={onSearchOrder}
              onSelectOrder={onSelectOrder}
            />
          </div>

          {selectedOrder && (
            <OrderDetailPanel order={selectedOrder} onClose={onCloseOrder} />
          )}
        </div>
      </div>

      <DownloadModal
        type={downloadType}
        invoice={selectedInvoice}
        onClose={() => setDownloadType(null)}
      />
    </div>
  );
};

export default PaymentsView;
